<template class="h-100">
	<b-container v-if="results || this.Preview" class="h-100 p-0 bg-white">
		<!-- OVERLAY DE CHARGEMENT-->
		<b-skeleton-wrapper :loading="Loading" class="row w-100 p-0 m-0 h-100">
			<template #loading>
				<b-col align-self="center">
					<div class="b-skeleton w-100 b-skeleton-icon b-skeleton-animate-fade bg-transparent text-gray-middle-dark"
						align-v="center">
						<font-awesome-icon icon="spell-check" size="6x" class="w-100"/>
					</div>
				</b-col>
			</template>
			<b-row class="d-flex justify-content-center">
				<b-col cols="6" class="p-0">
					<b-alert show :variant="Variant" class="p-1 text-center">
						{{ results.officialLabel }}
					</b-alert>
				</b-col>
			</b-row>
			<b-col v-if="context?.ShowConfigButtons" cols="12" class="d-flex justify-content-end">
				<b-dropdown dropright :text="$t('Tags')" :variant="Variant" toggle-class="border-0 rounded-pill h6" class="p-1">
					<b-dropdown-form form-class="px-1">
						<b-form-checkbox
							v-model="configs.WorkParameters.OfficialLabelsWorkParameters.displayConsumptionImg"
							:button-variant="Variant" class="ml-auto mr-0" switch>
							{{ $t('Consumptions') }} <!-- Consommations -->
						</b-form-checkbox>
						<b-form-checkbox
							v-model="configs.WorkParameters.OfficialLabelsWorkParameters.displayEmissionImg"
							:button-variant="Variant" class="ml-auto mr-0" switch>
							{{ $t('Emissions') }} <!-- Emissions -->
						</b-form-checkbox>
					</b-dropdown-form>
				</b-dropdown>
			</b-col>
			<!-- AFFICHAGE DES IMAGES DPE (ENERGIE PRIMAIRE / CO2) -->
			<b-col v-if="results.Errors && results.Errors.length == 0" class="d-flex justify-content-around align-items-center p-0 h-100 w-100">
				<!--IMAGE ENERGIE PRIMAIRE-->
				<b-img v-if="configs.WorkParameters.OfficialLabelsWorkParameters.displayConsumptionImg && results.rateEPImg" center fluid v-bind:src="'data:image/jpeg;base64,'+ results.rateEPImg"/>
				<b-col v-if="configs.WorkParameters.OfficialLabelsWorkParameters.displayConsumptionImg && !results.rateEPImg" class="m-1" cols="6">
					<b-alert variant="warning" show class="bold p-1 d-flex justify-content-center align-item-center" pill>
						<font-awesome-icon icon="spell-check" class="pr-2 fa-2xl"/>
						{{  $t('PleaseActualize') }}  <!-- Aucune donnée à afficher avec cette configuration. -->
					</b-alert>
				</b-col>
				<!--IMAGE CO2-->
				<b-img v-if="configs.WorkParameters.OfficialLabelsWorkParameters.displayEmissionImg && results.rateCo2Img" center fluid v-bind:src="'data:image/jpeg;base64,'+ results.rateCo2Img"/>
				<b-col v-if="configs.WorkParameters.OfficialLabelsWorkParameters.displayEmissionImg && !results.rateCo2Img" class="m-1" cols="6">
					<b-alert variant="warning" show class="bold p-1 d-flex justify-content-center align-item-center" pill>
						<font-awesome-icon icon="spell-check" class="pr-2 fa-2xl"/>
						{{  $t('PleaseActualize') }}  <!-- Aucune donnée à afficher avec cette configuration. -->
					</b-alert>
				</b-col>
				<b-col v-if="!configs.WorkParameters.OfficialLabelsWorkParameters.displayConsumptionImg && !configs.WorkParameters.OfficialLabelsWorkParameters.displayEmissionImg" class="m-1">
					<b-alert variant="primary" show class="bold p-1" pill>
						<font-awesome-icon icon="spell-check" class="pr-2 fa-2xl"/>
						{{  $t('NoData') }}  <!-- Aucune donnée à afficher avec cette configuration. -->
					</b-alert>
				</b-col>
			</b-col>
			<!-- Liste des messages d'erreurs à afficher -->
			<b-col v-else class="mt-1">
				<b-alert v-for="(error, index) in results.Errors" show :key="index" variant="danger-light" class="text-center"> {{ error }} </b-alert>
			</b-col>
		</b-skeleton-wrapper>
	</b-container>
</template>
<script lang="ts">
	/** COMPOSANTS VUE */
	import { Vue, Prop, InjectReactive } from "vue-property-decorator";
	import Component, { mixins } from 'vue-class-component';
	/** Classe Extention des works */
	import { WorkExtended } from "../Work";
	/** Classe utilisée */
	import Dictionary from "@/types/Dictionary";
	import Pin from "@/types/FilterTree/Pin";
	/** menu */
	import HscMenuStyleCustom from '@/components/commons/HscMenuStyleCustom';
	/** Elements d'état wiget */
	import OfficialLabelsState from '../Work/OfficialLabelsWork/OfficialLabelsState';
	import OfficialLabelsContext from '../Work/OfficialLabelsWork/OfficialLabelsContext';
	import locales from './locales/OfficialLabelsWork.json';
	
	/** Composant d'affichage des images DPE */
	@Component({
		components: {
			'hsc-menu-style-custom': HscMenuStyleCustom("secondary")
		},
		i18n : {messages : locales }
	})
	export default class OfficialLabelsWork extends mixins(WorkExtended<OfficialLabelsContext>, Vue) {
		
		//#region Attributs

		/** Noeud paramétré */
		@Prop()
		public Node!: Pin[];

		/** Id du widget */
		@Prop({default: 0})
		public WidgetId!: number;

		/** Bool pour la preview de données dans l'administration des widgets */
		@InjectReactive()
		protected Preview!: boolean;

		//#enregion

		//#region Méthodes composant

		created() {
			console.debug("Creation - OfficialLabelsWork", this.configs);
			
			if (this.results == undefined)
            	this.results = [{}];
		}

		async mounted() {
			/** Initialisation de la machine à état */
			this.initStateMachine<OfficialLabelsState>("OfficialLabels", (state, results: any, configs: Dictionary<any>, variant: string) => {
                return new OfficialLabelsContext(state as any, results, configs, variant)
            });
		}
		
		//#endregion
	}
</script>
<style scoped>

</style>